// extracted by mini-css-extract-plugin
export default {"wrapper":"B8","in_view":"C8","in_view_scrolled":"E8","img":"F8","content":"G8","icons":"H8","icon":"I8","text_wrapper":"J8"};
    if(module.hot) {
      // 1737143665165
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  